// A BP-split experiment resolves a profile to itself plus one of these suffixes, so a resolved profile
// that only differs by a suffix is still the incoming one. The suffix in the URL is a report, not an
// input: resolveBPV4 strips an incoming one before it looks anything up and re-derives the arm from
// searchId, cookies and headers, or from the cux* params — none of which this helper can see.
const withoutBpSplitSuffix = (businessProfile: string) => businessProfile.replace(/_PROMO2?$/, '');

/**
 * MPH-960: resolveBPV4 never fails loudly when the incoming profile has no product for the requested
 * search mode — it silently resolves to the hostname's default, or to the library's hardcoded
 * HOLIDAYSLASTMINUTECOUK when the hostname has no default for the mode either (train+hotel today).
 * Writing that substitute into the URL would replace the partner's profile while bf_source / utm_source
 * still credit the partner, so a later read of the URL names a different partner than the one that sent
 * the customer. The resolved profile may only be published when the URL carries none, or when it is the
 * incoming profile plus a BP-split suffix — a different arm of the profile that arrived, not a different
 * partner, and publishing it keeps the URL reporting the arm the page actually ran under.
 */
export const canPublishResolvedBusinessProfile = ({
  resolved,
  fromUrl,
}: {
  resolved: string | undefined;
  fromUrl: string | undefined | null;
}): boolean => {
  if (!resolved) return false;
  if (!fromUrl) return true;
  return withoutBpSplitSuffix(resolved) === withoutBpSplitSuffix(fromUrl);
};
